const toCarrierArray = (value) => {
  if (Array.isArray(value)) {
    return value;
  }
  if (Array.isArray(value?.content)) {
    return value.content;
  }
  if (Array.isArray(value?.responseData)) {
    return value.responseData;
  }
  return [];
};

export const normalizeCarrierOptions = (value) => toCarrierArray(value)
  .map((carrier) => ({
    code: carrier?.code ?? carrier?.value ?? "",
    nameRu: carrier?.nameRu ?? carrier?.name_ru ?? carrier?.label ?? carrier?.name ?? "",
  }))
  .filter((carrier) => carrier.code && carrier.nameRu);
